/* eslint-disable import/prefer-default-export */
export const cleanName = paramName => {
	const n = paramName || '';
	return n.replace(/\s+/gi, ' ').trim();
};
